<template>
  <div class="main-wrapper-container create-partner-page">
    <header-title :main-title="pageTitle" />
    <title-slot title="Логотип"/>
    <file-input
        :file="defaultFileInput"
        :active-file="form.logo"
        :is-active-img="true"
        @removeFile="form.logo = null"
        @changeFile="(value, file, fileSrc) => form.logo = { file, fileSrc }"
    />

    <title-slot title="URL"/>
    <input-main
        :value="form.url"
        :info-input="{ placeholder: 'Введите url' }"
        @changeValue="v => form.url = v.value"
    />


    <button-main @click="savePartner" :disabled="idDisabledButton">
      {{ isEditMode ? 'Сохранить изменения' : 'Создать партнера' }}
    </button-main>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex';
import HeaderTitle from '@/components/entities/HeaderTitle.vue';
import TitleSlot from '@/components/entities/TitleSlot.vue';
import InputMain from '@/components/shared/input/InputMain.vue';
import ButtonMain from '@/components/shared/buttons/ButtonMain.vue';
import FileInput from '@/components/shared/input/FileInput.vue';
import RulesMixin from '@/mixins/rules.mixin';
import {api} from "@/middleware/api";

export default {
  name: 'PartnerForm',
  components: { FileInput, TitleSlot, HeaderTitle, InputMain, ButtonMain },
  mixins: [RulesMixin],

  data() {
    return {
      form: {
        id: null,
        url: '',
        logo: null
      },
      defaultFileInput: {
        placeholder: "Загрузить логотип партнера",
        mimetype: 'image/png, image/jpeg, image/jpg',
        mimeTypeString: 'PNG, JPEG, JPG',
        size: 0.0035,
        title: 'Загрузите файл до 3.5 МБ',
      }
    };
  },

  computed: {
    ...mapGetters('partners', ['getById']),
    ...mapState('partners', ['partners']),
    idDisabledButton() {
      return !this.form.url.trim() || !this.form.logo;
    },
    isEditMode() {
      return !!this.$route.params.id;
    },
    pageTitle() {
      return this.isEditMode ? 'Редактировать партнера' : 'Новый партнер';
    }
  },

  watch: {
    partners() {
      this.prepareData()
    }
  },
  created() {
    this.prepareData()
  },

  methods: {
    ...mapActions('partners', ['addPartner', 'updatePartner']),
    prepareData() {
      if (this.isEditMode) {
        const partner = this.getById(this.$route.params.id);
        if (partner) {
          this.form = { ...partner, logo: { logoKey: partner.logoKey } };
        }
      }
    },
    async savePartner() {
      if (this.isEditMode) {
        try {
          if (!this.form.logo?.logoKey) {
            await api.dashboard.adminPartnersControllerUpdateLogo(this.form.id, {
              logo: this.form.logo.file
            })
          }
          await api.dashboard.adminPartnersControllerUpdate(this.form.id, {
            url: this.form.url,
          })
          this.updatePartner(this.form);
          this.alertSuccess('Изменения сохранены!');
          this.$router.push({ name: 'partners' });
        }
        catch (e) {
          console.log('Error updatePartner', e)
        }
      } else {
        try {
          const {data} = await api.dashboard.adminPartnersControllerCreate({ logo : this.form.logo.file, url : this.form.url });
          this.addPartner({data});
          this.alertSuccess('Партнер добавлен!');
          this.$router.push({ name: 'partners' });
        }
        catch (e) {
          this.alertError('Ошибка url');
        }

      }
    }
  }
};
</script>
<style scoped lang="scss">
.create-partner-page{
  max-width: 500px;
  .input-container, .input-file-img-container{
    height: 300px;
    width: 300px;
  }
}
</style>